import { __ } from "@wordpress/i18n";
import { useState } from "@wordpress/element";
import { X, Eye, CircleX, ScanEye } from "lucide-react";
import Preview from "./preview/Preview";

export default function PreviewWindow() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-6 right-6 z-50">
            {/* Chat Window */}
            <div
                className={`bg-white rounded-lg shadow-2xl transition-all duration-300 ease-in-out absolute bottom-20 right-0 w-64 ${
                    isOpen
                        ? "h-48 opacity-100 scale-100"
                        : "h-0 opacity-0 scale-95 pointer-events-none"
                }`}
                style={{ transformOrigin: "bottom right" }}
            >
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 rounded-t-lg flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Eye size={20} />
                        <h3 className="font-semibold text-white">
                            {__(
                                "Preview",
                                "wpbean-quantity-controls-for-woocommerce",
                            )}
                        </h3>
                    </div>
                    <button
                        title={__(
                            "Close",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        onClick={() => {
                            setIsOpen(false);
                        }}
                        className="hover:bg-blue-400 rounded p-1 transition-colors"
                    >
                        <X size={18} />
                    </button>
                </div>

                {/* Preview Area */}
                <div
                    className={`flex flex-col items-center justify-center p-4 space-y-3 transition-all duration-300 h-[134px] opacity-100`}
                >
                    <Preview />
                </div>
            </div>

            {/* Button */}
            <button
                title={__(
                    "Preview",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                onClick={() => setIsOpen(!isOpen)}
                className="bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
            >
                {isOpen ? <CircleX size={24} /> : <ScanEye size={24} />}
            </button>
        </div>
    );
}
